import { Phone, Plus, Trash2 } from "lucide-react";
import { inputCls, labelCls } from "./constants";

export default function PhonePlansSection({ phonePlans, setPhonePlans, updatePhone, addPhone }) {
  return (
    <section>
      <div className="flex items-center justify-between mb-4">
        <h3 className="flex items-center gap-2 font-bold text-slate-800 text-lg">
          <Phone size={18} className="text-[#1f3a8a]" /> Abonamenty na telefon
        </h3>
        <button data-testid="add-phone-plan" onClick={addPhone} className="inline-flex items-center gap-1 text-sm font-semibold text-[#1f3a8a] hover:text-[#15296b]">
          <Plus size={16} /> Dodaj pakiet
        </button>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {phonePlans.map((p, i) => (
          <div key={i} data-testid={`phone-plan-${i}`} className="rounded-xl border border-slate-200 p-4 bg-slate-50/50 space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-xs font-mono text-slate-400">{p.id}</span>
              <button onClick={() => setPhonePlans((prev) => prev.filter((_, idx) => idx !== i))} className="text-red-500 hover:text-red-700"><Trash2 size={15} /></button>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className={labelCls}>Nazwa</label>
                <input data-testid={`phone-name-${i}`} className={inputCls} value={p.name} onChange={(e) => updatePhone(i, "name", e.target.value)} />
              </div>
              <div>
                <label className={labelCls}>Cena (zł)</label>
                <input data-testid={`phone-price-${i}`} type="number" className={inputCls} value={p.price} onChange={(e) => updatePhone(i, "price", e.target.value)} />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className={labelCls}>Okres</label>
                <input className={inputCls} value={p.period} onChange={(e) => updatePhone(i, "period", e.target.value)} />
              </div>
              <div>
                <label className={labelCls}>Nagłówek (tagline)</label>
                <input className={inputCls} value={p.tagline || ""} onChange={(e) => updatePhone(i, "tagline", e.target.value)} />
              </div>
            </div>
            <div>
              <label className={labelCls}>Opis</label>
              <textarea className={inputCls} rows={2} value={p.description || ""} onChange={(e) => updatePhone(i, "description", e.target.value)} />
            </div>
            <div>
              <label className={labelCls}>Punkty (jeden w linii)</label>
              <textarea
                data-testid={`phone-features-${i}`}
                className={inputCls}
                rows={4}
                value={Array.isArray(p.features) ? p.features.join("\n") : p.features || ""}
                onChange={(e) => updatePhone(i, "features", e.target.value.split("\n"))}
              />
            </div>
            <label className="flex items-center gap-2 text-sm text-slate-700">
              <input type="checkbox" checked={!!p.featured} onChange={(e) => updatePhone(i, "featured", e.target.checked)} />
              Wyróżniony (polecany)
            </label>
          </div>
        ))}
      </div>
    </section>
  );
}
